import { animate } from "motion";

export default (autoplay_duration: number) => ({
  progress: -100,
  play() {
    animate(-100, 0, {
      ease: "linear",
      duration: autoplay_duration || 5,
      onUpdate: (latest) => (this.progress = latest),
    });
  },
});
